/**
 * The bridge between React and {@link CallAnnouncer}: runs it while the live
 * regions are mounted, and injects the contact lookup — the one thing the
 * announcer cannot derive from the store, since the name lives in MobX.
 */
import { MobXProviderContext } from 'mobx-react';
import { resolveCallContactInfo } from 'Modules/softphone/resolver/contactResolver';
import { CallAnnouncer } from 'Modules/softphone/services/CallAnnouncer';
import type { CallContactResolver } from 'Modules/softphone/services/CallAnnouncer';
import { useContext, useEffect } from 'react';
import type { RootStoreProps } from 'Stores/RootStore.types';

export const useSoftphoneAnnouncements = (): void => {
  const { person: personStore } = useContext(
    MobXProviderContext
  ) as RootStoreProps;

  useEffect(() => {
    const announcer = CallAnnouncer.getInstance();

    // The same lookup the header renders, so the spoken and visible names
    // cannot drift apart.
    const resolveContact: CallContactResolver = (call) => {
      const { displayName, phoneNumber } = resolveCallContactInfo(
        personStore,
        call
      );

      return displayName || phoneNumber || call.phoneNumber;
    };

    announcer.setContactResolver(resolveContact);
    announcer.start();

    return () => {
      announcer.stop();
      announcer.setContactResolver(null);
    };
  }, [personStore]);
};
